import { CTAButton } from "../common/CTAButton";

type FinalCTASectionProps = {
  title: string;
  button: { label: string; href: string };
};

export function FinalCTASection({ title, button }: FinalCTASectionProps) {
  return (
    <section className="bg-gradient-to-br from-slate-900 via-slate-950 to-slate-950 py-24" aria-labelledby="final-cta-heading">
      <div className="mx-auto max-w-4xl px-6 text-center">
        <h2 id="final-cta-heading" className="text-balance text-4xl font-semibold text-white sm:text-5xl">
          {title}
        </h2>
        <div className="mt-10 flex justify-center">
          <CTAButton href={button.href}>{button.label}</CTAButton>
        </div>
      </div>
    </section>
  );
}
